module.exports = __webpack_public_path__ + "static/mr-concert-performance-15-8c6caec9c7fd6f67768945cefb251a6e.jpg";